import cardholderIdField from '../../config/cardholder-id-markup';
import { cardholderIdAllowedLocales } from '../../config/primer';

export const cardholderIdActions = {
  dom: {
    documentTypeField: null,
    documentTypeChoiceField: null,
    dropdown: null,
    dropdownOptions: null,
    cardholderIdInput: null,
  },
  placeholders: {
    DNI: '99999999',
    Cédula: '999999999',
    'L.C.': '9999999',
    'L.E.': '9999999',
    Otro: '99999999999999999999',
    CPF: '999.999.999-99',
    CNPJ: '99.999.999/9999-99',
  },
  init() {
    this.addCardholderIdField();

    this.dom.documentTypeField = document.querySelector('#document-type-wrapper');
    this.dom.documentTypeChoiceField = document.querySelector('#document-type-choice');
    this.dom.dropdown = document.querySelectorAll('.document-type-dropdown')[1];
    this.dom.dropdownOptions = this.dom.dropdown?.querySelectorAll('li');
    this.dom.cardholderIdInput = document.querySelector('#primer-checkout-card-cardholder-id-input');

    const dropdownFirstOption = this.dom.dropdownOptions && this.dom.dropdownOptions[0].dataset.option;
    this.dom.documentTypeChoiceField && (this.dom.documentTypeChoiceField.textContent = dropdownFirstOption);
    this.dom.cardholderIdInput && (this.dom.cardholderIdInput.placeholder = this.placeholders[dropdownFirstOption]);
    this.addCardholderIdEventListeners();
  },
  addCardholderIdField() {
    if (cardholderIdAllowedLocales.includes(backEndVars.locale) && backEndVars.workflow === 'dlocal') {
      const cardholderIdContainer = document.createElement('div');
      cardholderIdContainer.innerHTML = cardholderIdField(backEndVars.tm1346, backEndVars.tm1347);
      const dropdown = document.querySelector('.document-type-dropdown').cloneNode(true);
      const docTypeChoice = cardholderIdContainer.querySelector('#document-type-choice');
      docTypeChoice.insertAdjacentElement('afterend', dropdown);
      const cardProvidersElem = document.querySelector('.card-providers-container');
      cardProvidersElem.insertAdjacentElement('afterend', cardholderIdContainer);
    }
  },
  addCardholderIdEventListeners() {
    this.dom.documentTypeField?.addEventListener('click', this.toggleDropdown.bind(this));
    this.dom.dropdownOptions?.forEach(option => option.addEventListener('click', this.selectDocumentType.bind(this)));
  },
  toggleDropdown() {
    this.dom.dropdown.classList.toggle('hidden');
  },
  selectDocumentType(event) {
    const option = event.currentTarget.dataset.option;
    this.dom.documentTypeChoiceField.textContent = option;
    this.dom.cardholderIdInput.placeholder = this.placeholders[option];
  },
  validateCardholderIdField() {
    const errorField = document.querySelector('#primer-checkout-cardholder-id-error .PrimerCheckout__helperText');
    const pattern = /^\s*$/;
    if (pattern.test(this.dom.cardholderIdInput.value)) {
      this.dom.cardholderIdInput.classList.remove('valid');
      this.dom.cardholderIdInput.classList.add('error', 'dirty');
      errorField.classList.remove('PrimerCheckout--exit', 'PrimerCheckout--exited', 'PrimerCheckout--hidden');
      errorField.classList.add('PrimerCheckout--enter', 'PrimerCheckout--entered');
      return false;
    }

    this.dom.cardholderIdInput.classList.remove('error');
    this.dom.cardholderIdInput.classList.add('valid');
    errorField.classList.remove('PrimerCheckout--enter', 'PrimerCheckout--entered');
    errorField.classList.add('PrimerCheckout--exit', 'PrimerCheckout--exited', 'PrimerCheckout--hidden');
    return true;
  },
};
